<template>
  <FormPanel
      headline="Create Primary Menu Link"
      :errors="errors"
      @submit="submit"
  />
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/PrimaryMenuLinks/Panels/Form'

export default {
  components: {FormPanel},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      errors: {}
    }
  },

  methods: {
    submit(data) {
      http.post('/api/v2/primary-menu-links', {...data, portal_id: this.portal.id})
          .then(() => {
            notify.success('The primary menu link was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/primary-menu-links')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
